import { memo, useCallback, useEffect, useState } from "react";
import { UserInfoCardProps } from "./types";
import { Button } from "ui/components/Button/Button";
import UserEditCard from "../UserEditCard/UserEditCard";
import { useTranslate } from "helpers";
import { TextField } from "ui/components/TextField/TextField";
import { PasswordField } from "ui/components/TextField/PasswordField";
import { EmailTextField } from "ui/components/TextField/EmailTextField";
import { PhoneTextField } from "ui/components/TextField/PhoneTextField";
import { MobilePhoneTextField } from "ui/components/TextField/MobilePhoneTextField";
import OibTextField from "ui/components/TextField/OibTextField/OibTextField";
import { MultiDropdown } from "ui/components/Dropdown/MultiDropdown";
import { NumberField } from "ui/components/TextField/NumberField";
import { TextArea } from "ui/components/TextField/TextArea";
import { UserRole } from "services/api/users/types";
import { getUserRolesAPI } from "services/api/users/api";
import { MultiDropdownOption } from "ui/components/Dropdown/MultiDropdown/types";
import { useDispatch } from "react-redux";

const UserInfoCard: React.FC<UserInfoCardProps> = (props) => {
  const { user, fetchUser } = props;

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const [userRoles, setUserRoles] = useState<UserRole[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  useEffect(() => {
    fetchUserRoles();
  }, [user.id]);

  const fetchUserRoles = async () => {
    setIsLoading(true);

    let result;
    try {
      result = await getUserRolesAPI();
    } catch {
      setIsLoading(false);
      return;
    }

    setUserRoles(result);
    setIsLoading(false);
  };

  const roleItems: MultiDropdownOption[] = userRoles.map((i) => {
    return {
      value: i.id.toString(),
      text: i.name,
    };
  });

  const handleEditSuccess = useCallback(() => {
    if (user.id) {
      dispatch(fetchUser(user.id) as any);
      setShowEditModal(false);
    }
  }, []);


  console.log('user', user)

  return (
    <>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              {t("admin.user.detail.basicinfo.title")}
            </p>
            <p className="text-sm">
              {t("admin.user.detail.basicinfo.description")}
            </p>

          </div>
        </div>
        <div className="flex justify-between items-center flex-1  px-3 my-3">
          <div className="flex flex-col">
            <div className="flex gap-4">
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextField
                  type="text"
                  name="firstName"
                  label={t("admin.user.detail.firstname")}
                  value={user.firstName}
                  disabled
                ></TextField>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextField
                  type="text"
                  name="lastName"
                  label={t("admin.user.detail.lastname")}
                  value={user.lastName}
                  disabled
                ></TextField>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <OibTextField
                  type="text"
                  name="oib"
                  label={t("admin.user.detail.oib")}
                  placeholder=""
                  value={user.oib}
                  required
                  disabled
                ></OibTextField>
              </div>
            </div>
          </div>
          <div>
            <Button
              variant="outlined"
              children={t("admin.edit")}
              onClick={() => setShowEditModal(true)}
              startIcon="/media/icons/plus.svg"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              {t("admin.user.detail.contact.title")}
            </p>
            <p className="text-sm">
              {t("admin.user.detail.contact.description")}
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1 px-3 my-3">
          <div className="flex flex-col">
            <div className="flex gap-4">
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextField
                  type="text"
                  name="userName"
                  label={t("admin.user.detail.username")}
                  value={user.userName}
                  disabled
                ></TextField>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <PasswordField
                  name="password"
                  label={t("admin.user.detail.password")}
                  value={user.password}
                  disabled
                  onChange={() => null}
                  required={false}
                />
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <MultiDropdown
                  label={t("admin.user.edit.roles")}
                  name="roles"
                  value={user.roles.map((role) => role.id.toString())}
                  options={roleItems}
                  onChange={() => null}
                  required
                  disabled
                ></MultiDropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              {t("admin.user.detail.contact.title")}
            </p>
            <p className="text-sm">
              {t("admin.user.detail.contact.description")}
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1 px-3 my-3">
          <div className="flex flex-col">
            <div className="flex gap-4">
              <div className="flex-1 mb-3 min-w-[300px]">
                <MobilePhoneTextField
                  type="text"
                  name="mobilePhoneNumber"
                  label={t("admin.user.detail.mobilephonenumber")}
                  placeholder=""
                  value={user.mobilePhoneNumber}
                  required
                  disabled
                ></MobilePhoneTextField>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <PhoneTextField
                  type="text"
                  name="phoneNumber"
                  label={t("admin.user.detail.phonenumber")}
                  placeholder=""
                  value={user.phoneNumber}
                  required
                  disabled
                  endIcon="/media/icons/phone.svg"
                ></PhoneTextField>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <EmailTextField
                  type="text"
                  name="email"
                  label={t("admin.user.detail.email")}
                  value={user.email}
                  required
                  disabled
                  endIcon="/media/icons/email.svg"
                ></EmailTextField>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              {t("admin.user.detail.address.title")}
            </p>
            <p className="text-sm">
              {t("admin.user.detail.address.description")}
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1 px-3 my-3">
          <div className="flex flex-col">
            <div className="flex gap-4">
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextField
                  type="text"
                  name="addressCountry"
                  label={t("admin.user.detail.addresscountry")}

                  value={user.addressCountry}
                  disabled
                ></TextField>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextField
                  type="text"
                  name="addressState"
                  label={t("admin.user.detail.addressstate")}

                  value={user.addressState}
                  disabled
                ></TextField>
              </div>

            </div>
            <div className="flex gap-4">
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextField
                  type="text"
                  name="addressCity"
                  label={t("admin.user.detail.addresscity")}
                  value={user.addressCity}
                  disabled
                ></TextField>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <NumberField
                  name="addressPostalCode"
                  label={t("admin.user.detail.postalcode")}
                  value={user.addressPostalCode}
                  decimals={0}
                  disabled
                ></NumberField>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextArea
                  name="addressLine1"
                  label={t("admin.user.detail.addresline1")}
                  onChange={() => null}
                  value={user.addressLine1}
                  disabled
                ></TextArea>
              </div>
              <div className="flex-1 mb-3 min-w-[300px]">
                <TextArea
                  name="addressLine2"
                  label={t("admin.user.detail.addresline2")}
                  onChange={() => null}
                  value={user.addressLine2}
                  disabled
                ></TextArea>
              </div>

            </div>
          </div>
        </div>
      </div>
      <UserEditCard
        userId={user?.id ?? null}
        show={showEditModal}
        onSuccess={handleEditSuccess}
        onClose={() => setShowEditModal(false)}
      />
    </>
  );
};

export default memo(UserInfoCard);
